export default __webpack_public_path__ + "static/media/smartVideo.cd12379e.svg";